import React, { FC } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormatDate from "go-core/components/Formatters/FormatDate";
import { ReactComponent as CalendarSVG } from "go-core/images/svg/calendar.svg";
import { ReactComponent as FileSVG } from "go-core/images/svg/file.svg";
import { ReactComponent as CalendarEditSVG } from "../../../../../../../../../images/svg/stocktaking/calendar-edit.svg";
import { ReactComponent as FileCheckSVG } from "../../../../../../../../../images/svg/stocktaking/file-check.svg";
import { ReactComponent as StockSVG } from "../../../../../../../../../images/svg/stocktaking/stock.svg";
import { StocktakingApi } from "../../../../../../../../../services/Api/Organization/types";

interface Props {
	stocktaking: StocktakingApi;
}

const StocktakingSummaryCard: FC<Props> = ({ stocktaking }) => {
	const { t } = useTranslation();

	return (
		<Card className="item-summary-card">
			<Card.Body>
				<div className="card-body-item">
					<div className="d-flex overflow-hidden">
						<StockSVG />
						<div className="item-info overflow-auto">
							<div className="d-flex flex-column">
								<span className="label">{t("common.word.stock")}:</span>
								<span>{stocktaking.stock.name}</span>
							</div>
						</div>
					</div>
				</div>
				<div className="card-body-item">
					<div className="d-flex">
						<FileSVG className="file-icon" />
						<div className="item-info">
							<div className="d-flex flex-column">
								<span className="label">
									{t("modules.stocktaking.field.stocktaking_number.title")}:
								</span>
								<span>{stocktaking.document_number}</span>
							</div>
						</div>
					</div>
				</div>
				<div className="card-body-item">
					<div className="d-flex">
						<CalendarSVG className="calendar-icon" />
						<div className="item-info">
							<div className="d-flex flex-column">
								<span className="label">{t("lib:common.word.created_at")}:</span>
								<span>{FormatDate(stocktaking.created_at)}</span>
							</div>
						</div>
					</div>
				</div>
				<div className="card-body-item">
					<div className="d-flex">
						<FileCheckSVG />
						<div className="item-info">
							<div className="d-flex flex-column">
								<span className="label">{t("modules.stocktaking.field.stocktaking_at.title")}:</span>
								<span>{FormatDate(stocktaking.stocktaking_at)}</span>
							</div>
						</div>
					</div>
				</div>
				<div className="card-body-item">
					<div className="d-flex">
						<CalendarEditSVG />
						<div className="item-info">
							<div className="d-flex flex-column">
								<span className="label">{t("modules.stocktaking.field.updated_at.title")}:</span>
								<span>{FormatDate(stocktaking.updated_at)}</span>
							</div>
						</div>
					</div>
				</div>
			</Card.Body>
		</Card>
	);
};

export default StocktakingSummaryCard;
